<template>
  <div class="radio-group">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String | Number,
      default: ''
    }
  },
  data() {
    return {}
  },
  watch: {
    value() {
      this.updateChildren()
    }
  },
  mounted() {
    this.updateChildren()
  },
  methods: {
    updateCheck(value) {
      if (this.value !== value) {
        this.$emit('input', value)
        this.$emit('change', value)
      } else {
        this.$emit('input', '')
        this.$emit('change', '')
      }
    },
    updateChildren() {
      this.$children.forEach((item) => {
        item.checked = this.value
      })
    }
  }
}
</script>
<style lang="scss" scoped></style>
